import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  className?: string;
}
export function Badge({
  children,
  className = ''
}: BadgeProps) {
  return <span className={`inline-block text-[0.72rem] uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#FEF2F2] text-[#8B1538] mr-1.5 font-semibold border border-[#FECACA] ${className}`} data-id="element-198">
      {children}
    </span>;
}